import Toolbox from "./toolbox";

/* General simple helpers */

// Is user opening the page into a new tab?
// This does not include opening from context menu (right click menu)
function openingToNewTab(e) {
	let tab = false;
	if (e.type === "auxclick") {
		tab = true;
	} else if (e.type === "click") {
		if (e.ctrlKey || e.metaKey) {
			tab = true;
		}
	}

	return tab;
}

function throttle(func, limit) {
	let inThrottle;

	return function() {
		const args = arguments;
		const context = this;
		if (!inThrottle) {
			func.apply(context, args);
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}

export { openingToNewTab, throttle };
